"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationType = void 0;
var IntegrationType;
(function (IntegrationType) {
    IntegrationType["ALIEN"] = "ALIEN";
    IntegrationType["ALIEN_STANDALONE"] = "ALIEN_STANDALONE";
    IntegrationType["ALIEN_WALLET_TRANSFER"] = "ALIEN_WALLET_TRANSFER";
    IntegrationType["CBET"] = "CBET";
    IntegrationType["DST"] = "DST";
    IntegrationType["EVERYMATRIX"] = "EVERYMATRIX";
    IntegrationType["SKYWIND"] = "SKYWIND";
    IntegrationType["PG_WALLET_TRANSFER"] = "PG_WALLET_TRANSFER";
    IntegrationType["EUROPE_BET"] = "EUROPE_BET";
    IntegrationType["VEGANGSTER"] = "VEGANGSTER";
})(IntegrationType || (exports.IntegrationType = IntegrationType = {}));
